import BaseParameters from './BaseParameters';

export default BaseParameters;
